import styled, { css } from "styled-components";
import { Col as AntdCol, Layout } from "antd";
import { Button2 } from "../../styles/buttons";

const inputCss = css`
  width: 100%;
  height: 2rem;
  padding: 0 11px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;

  &:focus,
  &:hover {
    border-color: ${(props) => props.theme.colors.cyanDark};
    outline-color: transparent;
  }

  &:focus {
    box-shadow: 0 0 0 2px rgb(22 158 173 / 20%);
  }
`;

export const Container = styled(Layout)`
  padding: 0.5rem 1rem;
  gap: 0.5rem;
  position: relative;

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }
`;

export const Button = styled(Button2)`
  width: unset;
  margin-top: 0;
  border-radius: 20px;

  @media (max-width: 576px) {
    width: 100%;
  }
`;

export const Label = styled.label`
  font-size: 18px;
  font-weight: bold;
`;

export const DateInputField = styled.input`
  ${inputCss}
`;

export const StatusBadge = styled.span<{ $active: boolean }>`
  padding: 4px 16px;
  border-radius: 12px;
  font-weight: 600;
  display: inline-block;
  color: white;
  background: ${({ $active }) => ($active ? "#4caf50" : "#9e9e9e")};
`;

export const Col = styled(AntdCol)`
  width: 12.4rem;
  margin-bottom: 0.8rem;

  input {
    ${inputCss}
  }

  @media (max-width: 768px) {
    min-width: 0;
  }

  @media (max-width: 576px) {
    width: 100%;
  }
`;
